import { render, staticRenderFns } from "./closuresGrid.vue?vue&type=template&id=6a576f82&scoped=true"
import script from "./closuresGrid.vue?vue&type=script&lang=js"
export * from "./closuresGrid.vue?vue&type=script&lang=js"
import style0 from "./closuresGrid.vue?vue&type=style&index=0&id=6a576f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a576f82",
  null
  
)

export default component.exports